import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Profile from '@/plugins/sdk/resources/Profile'
import Account from '@/plugins/sdk/resources/Account'

export default class extends Resource {
  static name = 'account_synclog'

  static get fields () {
    return {
      id: new UUID(),
      resource: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      profile: new ITEM(Profile),
      account: new ITEM(Account)
    }
  }
}
